const projects = [
  {
    id: 1,
    img: '/images/3.jpg',
    largeimg: '/images/3.jpg',
    heading: "Assotech Ltd",
    desc: "Did Internal Electrical work for 5 towers (Over 436 Flats) at Assotech Blith, Dwarka Expressway, Sec-99, Gurgaon (FDI Projects).",
    portrait: false
  },
  {
    id: 2,
    img: '/images/iit.jpeg',
    largeimg: '/images/iit.jpeg',
    heading: "Indian Institute of Technology",
    desc: "Did high side and low side electrical work at IIT Campus, Delhi.",
    portrait: false
  },
  {
    id: 3,
    img: '/images/hero.png',
    largeimg: '/images/hero.png',
    heading: "Hero Motors",
    desc: "33 KV sub-station work, high side and low side electrical work at Gurugram.",
    portrait: false
  },
  {
    id: 4,
    img: '/images/aiims.webp',
    largeimg: '/images/aiims.webp',
    heading: "AIIMS",
    desc: "Did high side and low side electrical work at AIIMS, Nagpur.",
    portrait: false
  },
  {
    id: 5,
    img: '/images/uprnn.jpg',
    largeimg: '/images/uprnn.jpg',
    heading: "UPRNN",
    desc: "Did fire fighting work for building of special police unit for women & children, Nanakpura, West Delhi.",
    portrait: true
  },
  {
    id: 6,
    img: '/images/it.jpeg',
    largeimg: '/images/it.jpeg',
    heading: "IT Park, Gurgaon",
    desc: "Did high side and low side electrical work at IT Park, Sector 18, Gurgaon.",
    portrait: true
  },
  {
    id: 7,
    img: '/images/3c.jpeg',
    largeimg: '/images/3c.jpeg',
    heading: "3 C Company",
    desc: "Did high side electrical work at Lotus 300, Sector 100, Noida.",
    portrait: false
  },
  {
    id: 8,
    img: '/images/golden.jpeg',
    largeimg: '/images/golden.jpeg',
    heading: "Golden Tulip",
    desc: "electrical substation system's work at their Delhi Hari Nagar.",
    portrait: false
  },
  {
    id: 9,
    img: '/images/bhavya.jpeg',
    largeimg: '/images/bhavya.jpeg',
    heading: "Bhavya Creators",
    desc: "33 KV grid sub-station work, high-side and low-side electrical work including plumbing, fire-fighting, and fire-detection works at FDDI Kanpa Road near Hero Cycle Co., Amhara Birta, Patna.",
    portrait: true
  },
  {
    id: 10,
    img: '/images/sm.jpeg',
    largeimg: '/images/sm.jpeg',
    heading: "Smart World",
    desc: "Did electrical work at Sector 89, Gurgaon.",
    portrait: true
  },
  {
    id: 11,
    img: '/images/sabs.webp',
    largeimg: '/images/sabs.webp',
    heading: "SABS Export",
    desc: "Did electrical work at Sector 63, Noida.",
    portrait: false
  },
  {
    id: 12,
    img: '/images/aarza.jpeg',
    largeimg: '/images/aarza.jpeg',
    heading: "Aarza Square",
    desc: "External & internal electrical works with plumbing and fire fighting works, Noida Extension, Gautam Budh Nagar.",
    portrait: false
  },
  {
    id: 13,
    img: '/images/m3m.jpeg',
    largeimg: '/images/m3m.jpeg',
    heading: "M3M Solitude",
    desc: "Electrical work at M3M Solitude, Sector 89, Gurgaon.",
    portrait: false
  },
  {
    id: 14,
    img: '/images/swg.jpeg',
    largeimg: '/images/swg.jpeg',
    heading: "Smart World Gems",
    desc: "Electrical work at Smart World Gems, Sector 89, Gurgaon.",
    portrait: true
  },
  {
    id: 15,
    img: '/images/HoABL.jpeg',
    largeimg: '/images/HoABL.jpeg',
    heading: "House of Abhinandan Lodha (HoABL)",
    desc: "Lighting, firefighting, plumbing and all MEP work.",
    portrait: false
  },
  {
    id: 16,
    img: '/images/pawam.jpeg',
    largeimg: '/images/pawam.jpeg',
    heading: "Heliport by Pawan Hans",
    desc: "External electrical works for heliport by Pawan Hans at Rohini Sector 36, Delhi.",
    portrait: false
  },
];

export default projects;
